import {IS_DEV} from '../env'

export const convertDatoCmsImgPathsToLocal = (str) => {
    if (!str) return str
    let replacement = '/datoCmsDownload'
    if (!IS_DEV) {
        replacement = `/static-pages-assets${replacement}`
    }
    return str.replace(/https:\/\/www\.datocms-assets\.com/g, replacement)
}

export const createMarkup = (htmlString) => {
    return {
        __html: convertDatoCmsImgPathsToLocal(htmlString),
    }
}
